import { apiClient } from '@api/client';
import type { AllowedSsoUser, DirectoryUser, SsoConnectionStatus } from '@schemas/api';

export const getMicrosoftSsoStatus = async (): Promise<SsoConnectionStatus> => {
  const { data } = await apiClient.get<SsoConnectionStatus>('/sso/microsoft/status');
  return data;
};

export const startMicrosoftSsoConnect = async (): Promise<{ admin_consent_url: string }> => {
  const { data } = await apiClient.post<{ admin_consent_url: string }>('/sso/microsoft/connect');
  return data;
};

export const disconnectMicrosoftSso = async (): Promise<void> => {
  await apiClient.delete('/sso/microsoft');
};

export const getMicrosoftDirectoryUsers = async (search?: string): Promise<DirectoryUser[]> => {
  const { data } = await apiClient.get<{ users: DirectoryUser[] }>(
    '/sso/microsoft/directory-users',
    { params: search ? { search } : undefined },
  );
  return data.users;
};

export const getMicrosoftAllowedUsers = async (): Promise<AllowedSsoUser[]> => {
  const { data } = await apiClient.get<{ users: AllowedSsoUser[] }>('/sso/microsoft/allowed-users');
  return data.users;
};

export const setMicrosoftAllowedUsers = async (
  externalUserIds: string[],
): Promise<AllowedSsoUser[]> => {
  const { data } = await apiClient.post<{ users: AllowedSsoUser[] }>('/sso/microsoft/allowed-users', {
    external_user_ids: externalUserIds,
  });
  return data.users;
};

export const revokeMicrosoftAllowedUser = async (allowedUserId: string): Promise<void> => {
  await apiClient.delete(`/sso/microsoft/allowed-users/${allowedUserId}`);
};

export const getGoogleSsoStatus = async (): Promise<SsoConnectionStatus> => {
  const { data } = await apiClient.get<SsoConnectionStatus>('/sso/google/status');
  return data;
};

export const startGoogleSsoConnect = async (): Promise<{ admin_consent_url: string }> => {
  const { data } = await apiClient.post<{ admin_consent_url: string }>('/sso/google/connect');
  return data;
};

export const disconnectGoogleSso = async (): Promise<void> => {
  await apiClient.delete('/sso/google');
};

export const getGoogleDirectoryUsers = async (search?: string): Promise<DirectoryUser[]> => {
  const { data } = await apiClient.get<{ users: DirectoryUser[] }>(
    '/sso/google/directory-users',
    { params: search ? { search } : undefined },
  );
  return data.users;
};

export const getGoogleAllowedUsers = async (): Promise<AllowedSsoUser[]> => {
  const { data } = await apiClient.get<{ users: AllowedSsoUser[] }>('/sso/google/allowed-users');
  return data.users;
};

export const setGoogleAllowedUsers = async (
  externalUserIds: string[],
): Promise<AllowedSsoUser[]> => {
  const { data } = await apiClient.post<{ users: AllowedSsoUser[] }>('/sso/google/allowed-users', {
    external_user_ids: externalUserIds,
  });
  return data.users;
};

export const revokeGoogleAllowedUser = async (allowedUserId: string): Promise<void> => {
  await apiClient.delete(`/sso/google/allowed-users/${allowedUserId}`);
};
